/* eslint-disable no-mixed-operators */
/* eslint-disable camelcase */
export const loadScript = function (src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script);
    script.onload = function () {
      resolve();
    };
    script.onerror = function () {
      reject();
    };
  });
};

export const getURLParameters = url => (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
  (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
  {},
);

export const PLATFORM = {
  WS: 'ws',
  WX: 'wx',
  QQ: 'qq',
  QZ: 'qz',
  WB: 'wb',
  OTHER: 'other',
};

export const getPlatform = function () {
  return isWX
    ? PLATFORM.WX
    : isQQ
      ? PLATFORM.QQ
      : isWS
        ? PLATFORM.WS
        : isQZ
          ? PLATFORM.QZ
          : PLATFORM.OTHER;
};

export const isAndroid = (() => /\bandroid\b/.test(navigator.userAgent.toLowerCase()))();

export const isIOS = (() => /\biphone os\b/.test(navigator.userAgent.toLowerCase()))();

export const isWX = (() => /\bmicromessenger\b/.test(navigator.userAgent.toLowerCase()))();

export const isWS = (() => /weishi/.test(navigator.userAgent.toLowerCase()))();

export const isQQ = (() => /\bqq\b/.test(navigator.userAgent.toLowerCase()))();

export const isQZ = (() => /\bqzone\b/.test(navigator.userAgent.toLowerCase()))();

export const isWB = (() => /\bweibo\b/.test(navigator.userAgent.toLowerCase()))();

export const isWXMSG = (() => isWX && getURLParameters(location.href).from === 'singlemessage')();

export const isWXTIMELINE = (() => isWX && getURLParameters(location.href).from === 'timeline')();

export const isPC = (() => {
  const ua = navigator.userAgent || '';
  const iPad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const iPhone = !iPad && (ua.match(/(iPhone\sOS)\s([\d_]+)/i) || ua.match('iPhone'));
  // const iPod = ua.match(/(iPod).*OS\s([\d_]+)/);
  const android = ua.match(/(Android)\s+([\d.]+)/) || ua.match(/Android/);
  const wp = ua.match(/Windows Phone ([\d.]+)/);
  const isMobile = iPad || iPhone || iPad || wp || android;

  return !isMobile;
})();

export const parseCookie = str => str
  .split(';')
  .map(v => v.split('='))
  .reduce((acc, v) => {
    try {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent((v[1] && v[1].trim()) || '');
    } catch (e) {
      const v0 = v && v.length > 0 ? v[0] : '';
      const v1 = v && v.length > 1 ? v[1] : '';
      console.error(`parse cookie error: key=${v0}, value=${v1}, e=${e}`);
    }
    return acc;
  }, {});

export const setCookie = (name, value, domain, path, hour) => {
  const expire = new Date();
  hour = hour || 24 * 365 * 10; // 默认10年
  expire.setTime(3600000 * hour + expire.getTime());
  document.cookie = `${name}=${value}; ${hour ? `expires=${expire.toGMTString()}; ` : ''}${
    path ? `path=${path}; ` : 'path=/; '
  }${domain ? `domain=${domain};` : ''}`;
  return true;
};

export const parseQQ = str => str.replace(/^o0*/, '');

export const getCookie = key => parseCookie(document.cookie)[key] || '';

export const getToken = (() => {
  let tmpSkey = null;
  let tmpToken = null;

  return (onlyUseSkey = false) => {
    let skey = '';
    if (onlyUseSkey) {
      skey = getCookie('skey');
    } else {
      skey =        getCookie('p_skey') || getCookie('skey') || getCookie('rv2') || getCookie('access_token');
    }
    let hash = 5381;
    let token = tmpToken;

    if (skey) {
      // 只有缓存中的skey失效时才重新生成gtoken
      if (skey !== tmpSkey) {
        tmpSkey = skey;
        for (let i = 0; i < skey.length; ++i) {
          hash += (hash << 5) + skey.charAt(i).charCodeAt();
        }
        tmpToken = hash & 0x7fffffff;
        token = hash & 0x7fffffff;
      }
    } else {
      // 不存在skey时,不需要token
      // 不需要token的时候传空的就好了, null兼容性有问题
      tmpToken = '';
      token = '';
    }

    return token;
  };
})();

export const getPersonId = () => getCookie('person_id');

export const getPersonIdBak = () => {
  const person_id = getPersonId();
  let personIdBak = '';
  if (person_id) return personIdBak;
  personIdBak = getCookie('person_id_bak');
  if (personIdBak) return personIdBak;
  personIdBak = `5${Math.random().toFixed(15)
    .replace(/0\./g, '')}`;
  setCookie('person_id_bak', personIdBak, document.domain, '/', 24);
  return personIdBak;
};
